export default __webpack_public_path__ + "static/media/costel.c4409305.webp";